export function extractEmailBody(htmlString: string) {
  const regExp = /<tbody>\s*<tr>\s*<td[^>]*>([\s\S]*?)<\/td>\s*<\/tr>\s*<\/tbody>/i;
  const match = htmlString.match(regExp);
  return match ? match[1] : '';
}
